import type { FC } from 'react';
import { useVehicleTypesForCustomerAndRouteAsOptionsWithFavoriteOptions } from '../../../../common/graphql/useVehicleTypesForCustomerAndRouteAsOptionsWithFavoriteOptions';
import { transformVehicleType } from '../../../../common/utils/optionTransformers';
import {
  VehicleTypeDropdownOption,
  VehicleTypeDropdownSingleValue,
} from '../../../../common/vehicle-types/vehicleTypeDropdownComponents';
import { DropdownField } from './fields/DropdownField';

export interface VehicleTypeFieldProps {
  customerNo: number | null;
  disabled?: boolean;
  id?: string;
  routeCode: string | null;
}

export const VehicleTypeField: FC<VehicleTypeFieldProps> = ({
  customerNo,
  disabled = false,
  routeCode,
  id,
}) => {
  const options = useVehicleTypesForCustomerAndRouteAsOptionsWithFavoriteOptions(
    customerNo,
    routeCode,
  );

  return (
    <DropdownField
      id={id}
      trackerCategory={'Details'}
      name={'vehicleType'}
      disabled={disabled}
      transformOption={transformVehicleType}
      components={{
        Option: VehicleTypeDropdownOption,
        SingleValue: VehicleTypeDropdownSingleValue,
      }}
      options={options}
    />
  );
};
